import moment from "moment";
import Modal from '@mui/material/Modal';
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useParams } from 'react-router-dom';

import CloseBtn from "../../../../../images/dataRepo/closebtn.svg";
import { toggleModal } from "../../../../reducers/modalReducer.js";
import { getRequest, postRequest, showMessage } from '../../../../config';

export default function ResearchAid() {

    const location = useLocation();
    const dispatch = useDispatch();

    const modal = useSelector(state => state.modal);

    const company = location.state?.company;
    // const reportType = new URLSearchParams(location.search).keys().next().value;

    let [prompt, setPrompt] = useState('');
    let [reportId, setReportId] = useState();
    let [reportType, setReportType] = useState();
    let [attachment, setAttachment] = useState([]);
    let [reportData, setReportData] = useState({});
    let [showFiles, setShowFiles] = useState(false);
    let [isGenerateFocusAreas, setIsGenerateFocusAreas] = useState(true);
    let [focusArea, setFocusArea] = useState({ focus1: '', focus2: '', focus3: '' });
    let [focusAreaCount, setFocusAreaCount] = useState({ focus1: 0, focus2: 0, focus3: 0 });
    // OPTIMIZATION: Lazy load reports when not available (excluded in lightweight mode)
    let [reports, setReports] = useState([]);

    // Fetch reports if not available
    useEffect(() => {
        const fetchReports = async () => {
            if (company?._id && company?.['reportsCount'] !== undefined && !company?.['researchAidReports'] && !company?.['customReports']) {
                try {
                    const response = await getRequest(`/company/${company._id}/reports`);
                    if (response['code'] == 200 && response['body']?.['reports']) {
                        // Merge both report arrays
                        const allReports = [...(response['body']['reports']['researchAidReports'] || []), ...(response['body']['reports']['customReports'] || [])];
                        setReports(allReports);
                    }
                } catch (e) {
                    console.error('Failed to fetch reports:', e);
                }
            }
        };
        fetchReports();
    }, [company?._id, company?.['reportsCount']]);

    useEffect(() => window.scrollTo(0, 0), []);

    useEffect(() => {
        if (window.location.hash) {
            reportId = window.location.hash.split('?')[0];
            reportType = window.location.hash.split('?')[1];

            if (reportType) setReportType(reportType);
            if (reportId) {
                reportId = reportId.replaceAll('#', '')
                setReportId(reportId);
            }
        }
        else {
            reportType = window.location.search;
            if (reportType) {
                reportType = reportType.replaceAll('?', '')
                setReportType(reportType);
            }
        }
    }, []);

    useEffect(() => {
        if (reportData?.['fileurl'] && reportData['fileurl'].length > 0) {
            reportData['fileurl'].map(file => attachment.push(file));
            setAttachment(attachment);
            setShowFiles(true);
        }
    }, [reportData]);

    useEffect(() => {
        if (company?.['_id']) {
            // Use lazy-loaded reports or fallback to company data
            const customReports = company?.['customReports'] || reports.filter(r => r.reportType === 'customReport');
            const researchAidReports = company?.['researchAidReports'] || reports;

            if (reportId && reportType == 'customReport') customReports?.filter(report => { if (report['_id'] == reportId) { setReportData(report); setPrompt(report['prompt']) } });
            else if (reportId && reportType) researchAidReports?.filter(report => { if (report['_id'] == reportId) setReportData(report) });
            else researchAidReports?.filter(report => { if (report['reportType'] == reportType) setReportData(report) });
        }
        if (company?.['_id'] && reportType && isGenerateFocusAreas) {
            setIsGenerateFocusAreas(false);
            generateFocusAreas(company['_id'], reportType);
        }
    }, [company, reportId, reportType, reports]);

    const generateFocusAreas = async (companyId, reportType) => {
        let res = await postRequest(`/company/generateFocusAreas`, { companyId, reportType });
        if (res?.['code'] == '200') {
            let prepopulateFiles = res['body']['files'];
            let prepopulateFocusArea = res['body']['focusArea'];
            if (prepopulateFiles && prepopulateFiles.length > 0) {
                prepopulateFiles.map(file => attachment.push(file));
                setAttachment(attachment);
                setShowFiles(true);
            }
            if (prepopulateFocusArea) {
                if (prepopulateFocusArea['focus1']) setFocusArea({ ...focusArea, focus1: prepopulateFocusArea['focus1'] });
                if (prepopulateFocusArea['focus2']) setFocusArea({ ...focusArea, focus2: prepopulateFocusArea['focus2'] });
                if (prepopulateFocusArea['focus3']) setFocusArea({ ...focusArea, focus3: prepopulateFocusArea['focus3'] });
            }
        }
    };

    const handleAreaFocus = async (e) => {
        if (e.target.value.length <= 200) {
            setFocusArea({ ...focusArea, [e.target.name]: e.target.value });
            focusAreaCount = { ...focusAreaCount, [e.target.name]: e.target.value.length };
            setFocusAreaCount(focusAreaCount);
        }
    };

    const onDragOver = e => e.preventDefault();
    const onDrop = (e) => {
        e.preventDefault();
        e.target.files = e.dataTransfer.files;
        const fileInput = e.currentTarget.querySelector("input[type='file']");
        if (fileInput) fileInput.value = null; // Reset the input field
        handleFileUpload(e);
    };

    const handleFileUpload = (e) => {
        if (e.target.files) {
            setShowFiles(false);
            for (const file of e.target.files) attachment.push(file) - 1;
            e.preventDefault();
            setAttachment(attachment);
            setTimeout(() => setShowFiles(true), 100);
            const fileInput = e.currentTarget.querySelector("input[type='file']");
            if (fileInput) fileInput.value = null; // Reset the input field
        }
    };

    const deleteUploadedFile = (file) => {
        setShowFiles(false);
        let index = attachment.indexOf(file);
        if (index > -1) attachment.splice(index, 1);
        setAttachment(attachment);
        setTimeout(() => setShowFiles(true), 100);
    };

    const handleGenerateReport = async () => {
        if (reportType == 'customReport' && prompt == '') return showMessage('Please enter the required prompt');
        try {
            let data, res;
            if (reportType == 'customReport') {
                if (reportId) data = { reportId, reportType, prompt, attachment, focusArea };
                else data = { reportType, prompt, attachment, focusArea };
            }
            else data = { reportType, query: 'create a detailed report using provided system message', attachment, focusArea };

            dispatch(toggleModal({ open: 'generateResearchAid' }));
            if (reportType == 'customReport') res = await postRequest(`/company/customReport/${company['_id']}`, data);
            else res = await postRequest(`/company/generateReport/${company['_id']}`, data);

            if (res['code'] == 200) {
                showMessage(res['message']);
                window.location.href = `/company/${company['_id']}#${res['body']['reportId']}?${reportType}-researchaid`;
            }
            else showMessage(res['message']);
            dispatch(toggleModal({ open: '' }));

        } catch (error) {
            console.error(error);
            showMessage('Something went wrong.');
        }
    };

    return (
        <div class='w100 df jcc pt6rem pb2rem research-genrate-page'>
            <div className='df fdc w80 px3rem'>
                <div class='df'>
                    <Link to={`/company/${company?.['_id']}`} onClick={() => localStorage.setItem('isResearchAid', true)}>
                        <svg className='cp mr1rem' width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z" fill="#151313" />
                        </svg>
                    </Link>
                    <h2 class='w100 c15 fs1-25rem fw500 mb0-5rem'>{reportData?.['name'] ? reportData['name'] : 'Create Your ResearchAid Report'}</h2>
                </div>
                {reportData?.['updatedAt'] && <p class='w100 fs1rem c36 fw300'>Last edited <b>{moment(reportData['updatedAt']).format('ll')}</b></p>}

                {/* Description */}
                <h3 className='w100 c15 fs1rem fw400 lh2 my1rem'>1. Description <span className='fs0-75rem c16 fsi'>(predefined)</span></h3>
                <textarea rows='8' className='bg1 bss bw2px bo5 w100 br10px p1rem mb1rem fs0-75rem c12' value={company?.['companyDescription'] || ''} readOnly />
                {reportType == 'customReport' && <>
                    <h3 className='w100 c15 fs1rem fw400 lh2 mb0-5rem'>Prompt * <span className='fs0-75rem c16 fsi'>(required)</span></h3>
                    <textarea value={prompt || reportData?.['prompt']} onChange={(e) => setPrompt(e.target.value)} rows='6' className='bg1 bss bw2px bo5 w100 br10px p1rem mb2rem fs0-75rem c12' />
                </>}

                {/* Areas of focus */}
                <h3 className='w100 c15 fs1rem fw500 lh2 my0-5rem'>2. Areas of your specific focus <span className='fs0-75rem c16 fsi' style={{ color: '#15131330' }}>(optional)</span></h3>
                <h4 className='w100 c15 fs0-875rem fw400 lh2 mb1rem'>To increase relevance you are welcome to add up to three areas of your specific report focus </h4>
                {['focus1', 'focus2', 'focus3'].map((item, idx) => {
                    return <div className='pr mb-05rem'>
                        <label className='c15 fs0-75rem my0-5rem db w100'>0{idx + 1} - Area of focus</label>
                        <textarea value={focusArea[item] || reportData?.['focusArea']?.[item]} onChange={(e) => handleAreaFocus(e)} onBlur={(e) => handleAreaFocus(e)} onInput={(e) => handleAreaFocus(e)} rows='3' style={{ background: '#F4FFE1' }} name={item} className='bss bw2px bo5 w100 br10px p1rem mb1rem fs0-75rem'
                            placeholder='Write your objective focus in your own words (up to 200 characters max)'></textarea>
                        <span className={`pa b0 r0 mb2rem mr1rem fs0-75rem ${focusAreaCount[item] >= 199 ? 'c4' : 'c16'}`}>{focusAreaCount[item]}/200</span>
                    </div>
                })}

                {/* Areas of your specific focus */}
                <h3 className='w100 c15 fs1rem fw500 lh2 mt1rem mb0-5rem'>3. Add files <span className='fs0-75rem c16 fsi' style={{ color: '#15131330' }}>(optional)</span></h3>
                <h4 className='w100 c15 fs0-875rem fw400 lh2 mb1rem'>If you have any document that will add context or background to this report, please upload it here. </h4>
                <label onDragOver={onDragOver} onDrop={(e) => onDrop(e)} for="fileUpload" className="w100 bsbb bg50 br5px df jcc fdc aic px2rem py1rem bsd bo3 bw2px cp mb0-5rem">
                    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M59.4632 31.0446C58.5439 25.1606 53.4429 20.6445 47.3047 20.6445C44.9955 20.6445 42.7766 21.2834 40.852 22.4751C37.924 17.5543 32.6528 14.4922 26.7969 14.4922C17.7506 14.4922 10.3906 21.8522 10.3906 30.8984C10.3906 30.9545 10.3906 31.0126 10.3927 31.0687C4.57871 32.048 0 37.1168 0 43.2031C0 49.9883 5.65619 55.5078 12.4414 55.5078H57.5586C64.3438 55.5078 70 49.9883 70 43.2031C70 37.0649 65.3472 31.9639 59.4632 31.0446Z" fill="white" />
                        <g clip-path="url(#clip0_5984_51759)">
                            <path d="M35 56C42.732 56 49 49.732 49 42C49 34.268 42.732 28 35 28C27.268 28 21 34.268 21 42C21 49.732 27.268 56 35 56Z" fill="#4A67FF" />
                            <path d="M34.9896 49.6555C33.746 49.6555 32.5026 49.6555 31.2593 49.6555C29.5542 49.6555 28.3237 48.4294 28.315 46.7248C28.3117 46.1298 28.3117 45.5346 28.315 44.9392C28.3182 44.3256 28.6901 43.9308 29.2589 43.9297C29.8276 43.9286 30.2044 44.3207 30.2082 44.9338C30.2121 45.5468 30.2082 46.1456 30.2082 46.7516C30.2126 47.387 30.5861 47.7573 31.2238 47.7578C33.7427 47.7578 36.2614 47.7578 38.78 47.7578C39.4182 47.7578 39.7922 47.387 39.7971 46.7521C39.8015 46.1462 39.7971 45.5402 39.7971 44.9343C39.7971 44.3284 40.175 43.9286 40.746 43.9297C41.3169 43.9308 41.6943 44.3256 41.6893 44.9387C41.6833 45.7136 41.7265 46.4967 41.6292 47.2613C41.4509 48.6602 40.2582 49.6478 38.8429 49.6544C37.5615 49.6582 36.2753 49.6555 34.9896 49.6555Z" fill="white" />
                            <path d="M34.0577 37.6102C33.9133 37.7448 33.8286 37.8186 33.7498 37.8979C33.1439 38.5098 32.5412 39.1256 31.9325 39.7354C31.5005 40.1685 30.8984 40.2002 30.5079 39.8212C30.1175 39.4423 30.1328 38.8205 30.5577 38.3928C31.7947 37.1481 33.0358 35.9078 34.2808 34.6719C34.7183 34.2344 35.2904 34.2344 35.7279 34.6719C36.9813 35.9151 38.2296 37.1636 39.4729 38.4174C39.8819 38.8303 39.8841 39.451 39.504 39.8218C39.124 40.1926 38.5197 40.1762 38.1024 39.7622C37.4844 39.147 36.8758 38.5219 36.2622 37.9028C36.1829 37.823 36.0981 37.7486 35.9718 37.6294C35.9636 37.8011 35.9537 37.9121 35.9537 38.0231C35.9537 39.9804 35.9565 41.9371 35.9537 43.8944C35.9537 44.6288 35.3073 45.0658 34.6352 44.8044C34.2633 44.6595 34.0615 44.3368 34.0615 43.8643C34.0593 41.9284 34.0593 39.9926 34.0615 38.057L34.0577 37.6102Z" fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_5984_51759">
                                <rect width="28" height="28" fill="white" transform="translate(21 28)" />
                            </clipPath>
                        </defs>
                    </svg>
                    <span className="pen fs1rem fw500 c49 tac op80 mt1rem mb2rem fsi">Click here or drag and drop files (max 10MB)</span>
                    <input onChange={(e) => handleFileUpload(e)} className="dn" id="fileUpload" type="file" multiple accept="application/*" />
                </label>
                <div className="df fww my1rem mah20 oscy">
                    {showFiles && attachment.length > 0 && attachment.map(file => {
                        let fileName;
                        if (file?.['name']) fileName = file['name']
                        else {
                            fileName = file.split('/')
                            fileName = fileName[fileName.length - 1]
                        }
                        return <div className={`df jcc aic br5px lh1 px1rem py0-5rem fw600 mr0-5rem mb0-5rem cp pr pageCutBg upload-file`} >
                            <span className="py0-5rem pl0-5rem">{fileName}</span>
                            <CloseBtn onClick={() => deleteUploadedFile(file)} className="mx1rem" />
                        </div>
                    })}
                </div>
                {/* Generate Report */}
                <div className='w100 pr b0 df jcsb px2rem pr4rem mt2rem'>
                    <p className='c15 fs1rem'></p>
                    <button onClick={() => handleGenerateReport()} className={`shadow c1 fw400 fs1rem pr br38px w200px h3rem df aic jcc bg4 bg3-hover cp`}>
                        Ok, next
                        <i className='icon pr ml0-5rem' style={{ top: '3px' }}>
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z" fill="white" />
                            </svg>
                        </i>
                    </button>
                </div>
            </div>
            <div className='w20 sidebar-researchaid-img' style={{ border: '1px solid #82828234', borderRight: 'none', borderBottom: 'none', backgroundColor: '#F9F9FF' }}>
                <img className="pa" style={{ right: '10px' }} src={require(`../../../../../images/generate-research-aid-ai.png`)} alt="research-aid-ai" />
            </div>

            {/* Generate Research Aid Popup */}
            <Modal id="generateResearchAid" open={modal['open'] == 'generateResearchAid'} className="backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore">
                <div className="poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr" style={{ outline: 'none', paddingBottom: '2rem', maxWidth: '750px' }}>
                    <div className='top-logo pa t0 r0 mr1rem mt1rem'><img className='w4rem' src={require('../../../../../images/favicon.png')} alt="" /></div>
                    <div className='creaing-modal pr mb3rem'>
                        <div className='df jcc'><img className="w10rem" src={require('../../../../../images/wizard.gif')} alt="" /></div>
                        <div className='text-box w90 df jcc tac fdc mla mra'>
                            <h3 className='fs1-25rem fw500 c15 mb1rem'>Generating Your Diligentsia ResearchAid Report</h3>
                            <div className="my1rem tac">
                                <div className="checklist-progress"><div className={`checklist-progress-bar questions-progress-bar`}></div></div>
                            </div>
                            <p className='c15 fs1rem mt1rem'>This may take a few minutes</p>
                        </div>
                        <div className='img-box pa' style={{ top: '10px', right: '-345px' }}><img className="" src={require(`../../../../../images/generate-research-aid-popup.png`)} alt="" /></div>
                    </div>
                </div>
            </Modal>
        </div >
    )
}